"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _request = _interopRequireDefault(require("@/utils/request"));

var _elementUi = _interopRequireDefault(require("element-ui"));

var _qs = _interopRequireDefault(require("qs"));

var panelApi = {
  customerDetail: function customerDetail(query) {
    return (0, _request.default)({
      url: '/customer/read',
      method: 'get',
      params: query
    });
  },
  switchCustomer: function switchCustomer(query) {
    return (0, _request.default)({
      url: '/customer/find',
      method: 'get',
      params: query
    });
  },
  updateCustomer: function updateCustomer(data) {
    return (0, _request.default)({
      url: '/customer/update',
      method: 'post',
      data: data,
      paramsSerializer: function paramsSerializer(params) {
        return _qs.default.stringify(params, {
          arrayFormat: 'repeat'
        });
      }
    });
  },
  updateCustomerLabel: function updateCustomerLabel(data) {
    //客户标签更新
    return (0, _request.default)({
      url: '/customer/updateLabel',
      method: 'post',
      data: data
    });
  },
  // 话务记录
  calllogRecord: function calllogRecord(query) {
    return (0, _request.default)({
      url: '/calllogRecord/list',
      method: 'get',
      params: query
    });
  },
  // 电访结果
  calllogCreate: function calllogCreate(data) {
    return (0, _request.default)({
      url: '/calllog/create',
      method: 'post',
      data: data
    });
  },
  // 咨询投诉内容列表
  ticketConsultList: function ticketConsultList(query) {
    return (0, _request.default)({
      url: '/workOrderConsult/list',
      method: 'get',
      params: query
    });
  },
  // 工单处理结果
  ticketResult: function ticketResult(query) {
    return (0, _request.default)({
      url: '/workOrderResult/ticketResult',
      method: 'get',
      params: query
    });
  },
  // 首页数据
  getIndexData: function getIndexData(query) {
    return (0, _request.default)({
      url: 'index/index',
      method: 'get',
      params: query
    });
  },
  //根据id查询campaign
  getCampaignConsult: function getCampaignConsult(query) {
    return (0, _request.default)({
      url: 'campaign/consult',
      method: 'get',
      params: query
    });
  },
  // GET /admin/sendSms/getTemplate获取短信模板
  getTemplate: function getTemplate(query) {
    return (0, _request.default)({
      url: 'sendSms/getTemplate',
      method: 'get',
      params: query
    });
  },
  // 上传图片/admin/storage/create
  uploadPicSingle: function uploadPicSingle(data) {
    return (0, _request.default)({
      url: '/storage/create',
      method: 'post',
      data: data
    });
  },
  saveDamageFile: function saveDamageFile(data) {
    return (0, _request.default)({
      url: '/workOrder/saveDamageFile',
      method: 'post',
      data: data
    });
  },
  //获取需要缓存的信息
  getBaseData: function getBaseData() {
    return (0, _request.default)({
      url: '/baseData/getBaseData',
      method: 'get'
    });
  },
  // /admin/ticket/sendMsNoConnect发送短信通知-未拨通用户
  sendMsNoConnect: function sendMsNoConnect(data) {
    return (0, _request.default)({
      url: '/workOrder/sendMsNoConnect',
      method: 'post',
      data: data
    });
  },
  //获取客户信息中的tab内容
  getCustomerTabData: function getCustomerTabData(query) {
    return (0, _request.default)({
      url: 'customer/getTabData',
      method: 'get',
      params: query
    });
  },
  //电访任务列表
  getBuiltListCnt: function getBuiltListCnt(query) {
    return (0, _request.default)({
      url: '/builtList/list',
      method: 'get',
      params: query,
      paramsSerializer: function paramsSerializer(params) {
        return _qs.default.stringify(params, {
          arrayFormat: 'repeat'
        });
      }
    });
  },
  //电访任务列表
  getBuiltListDetail: function getBuiltListDetail(query) {
    return (0, _request.default)({
      url: '/builtList/detail',
      method: 'get',
      params: query,
      paramsSerializer: function paramsSerializer(params) {
        return _qs.default.stringify(params, {
          arrayFormat: 'repeat'
        });
      }
    });
  },
  //获取一条电访任务
  getBuiltCallOut: function getBuiltCallOut(query) {
    return (0, _request.default)({
      url: '/builtList/getBuilt',
      method: 'get',
      params: query
    });
  }
};
var _default = panelApi;
exports.default = _default;